<script setup lang="ts"></script>

<template>
  <icon name="iconoir:sort-up" />
</template>

<style scoped></style>
